import React from 'react'
 
 const EmpContext=React.createContext();

export default EmpContext